import Reveal from "../components/Reveal";

/**
 * Only integrations verified as customer-accessible today. Do not add anything
 * to this list without confirming the end-user can actually use it in the
 * production application.
 */
const INTEGRATIONS = [
  { name: "Google Calendar", role: "Two-way calendar sync" },
  { name: "Microsoft Outlook", role: "Two-way calendar sync" },
  { name: "Google Meet", role: "Auto-generated meeting links" },
  { name: "Microsoft Teams", role: "Auto-generated meeting links" },
  { name: "Stripe", role: "Web billing & invoice payments" },
  { name: "Apple StoreKit", role: "iOS in-app subscriptions" },
];

export default function IntegrationsGrid({ compact = false }) {
  return (
    <section
      data-testid="integrations-grid"
      className={compact ? "py-16" : "py-24 lg:py-32"}
      style={{ background: "#FAF7F2" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl mb-12">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
            Integrations
          </div>
          <h2 className="font-display font-extrabold text-[30px] sm:text-[40px] leading-[1.1] tracking-[-0.02em] text-[#1A2A3A] mb-4">
            Works with the tools your day already runs on.
          </h2>
          <p className="text-[16px] text-[#57534E] leading-relaxed">
            We only list what you can actually connect today. More coming, but
            we don't advertise them until they ship.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {INTEGRATIONS.map((i, idx) => (
            <Reveal key={i.name} delay={idx * 40}>
              <div className="p-5 rounded-2xl bg-white border border-[#E8E2D9] hover:border-[#E8712C]/40 transition-colors">
                <div className="font-display font-bold text-[16px] text-[#1A2A3A] tracking-[-0.01em]">
                  {i.name}
                </div>
                <div className="mt-1 text-[13px] text-[#57534E]">{i.role}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
